import { gql } from '@apollo/client';
import { TRANSACTION_FRAGMENT } from './TRANSACTION_FRAGMENT';

export const COMPLETE_TRANSACTION_MUTATION = gql`
  mutation CompleteTransaction($id: Int!, $source: TransactionSource!) {
    in {
      completeTransaction(id: $id, source: $source) {
        success
        message {
          code
          message
        }
        content {
          ...TransactionFragment
        }
      }
    }
  }
  ${TRANSACTION_FRAGMENT}
`;
